import React from 'react';
import LazyLoad from 'react-lazyload';

const Accessory = ({ accessory }) => {
	return (
		<li>
			<a
				href={ accessory.accessoryUrl }
				onClick={ () => {
					global.dataLayer.push({
						event: 'Accessory Tile',
						eventCategory: 'Accessory Tiles',
						eventAction: global.location.pathname,
						eventLabel: accessory.title
					});
				} }
			>
				<div className="product-img">
					<LazyLoad once={ true } offset={ 200 }>
						<img src={ accessory.imageUrl } alt="" />
					</LazyLoad>
				</div>
				<h3 className="product-title">
					{ accessory.title }
				</h3>
			</a>
		</li>
	);
};

export default Accessory;


// WEBPACK FOOTER //
// ./src/pages/product/accessories/Accessory.js